import { Switch } from '@material-ui/core';
import CSS from 'csstype';
import React from 'react';

import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';

interface IProps {
  isChecked: boolean;
  handleSwitch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  labelStyle?: CSS.Properties;
  small?: boolean;
  key: string;
  inputID: string;
  isDisabled?: boolean;
}

export const SimpleSwitch = ({
  isChecked,
  handleSwitch,
  label,
  labelStyle = {},
  small,
  inputID,
  isDisabled,
}: IProps) => {
  return (
    <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
      <Col>
        <Switch
          checked={isChecked}
          onChange={handleSwitch}
          id={inputID}
          size={small ? 'small' : 'medium'}
          disabled={isDisabled}
        />
      </Col>
      {label && (
        <Col>
          <Text small disableSelect style={labelStyle}>
            {label}
          </Text>
        </Col>
      )}
    </Cols>
  );
};
